import { getClassName } from '../../utils/formatter';

function FeatureImportanceTable(props: any) {
    const {label, value, index, onClick} = props;
  return (
    <>
        <div onClick={onClick} key={index} className="grid grid-cols-[2fr_1fr] border-b border-[#BEBEBE]">
            <div className={`chart-subtitle p-2 ${index % 2 === 0 ? 'bg-[#F1F1F180]' : ''}`}>{label || "-"}</div>
            <div className={`chart-subtitle p-2 border-l border-[#BEBEBE] text-center font-bold ${getClassName(value)}`}>{value || "-%"}</div>
        </div>
    </>
  )
}

export default FeatureImportanceTable;
